import { QUESTION_TYPE } from '../../../../constants/questionTypes';
import type { RatingMatrixQuestion } from '../../../../types/index';
import type { ApiQuestion } from '../../../../internalTypes';
import type { ResolvedQuestionShell } from '../shared/resolveQuestionShell';
import { detectDisplayStyle } from '../shared/detectDisplayStyle';
import { detectMatrixFormat } from '../shared/detectMatrixFormat';
import { extractHintLabels } from '../labels/extractHintLabels';
import { buildScaleColumns } from '../matrix/buildScaleColumns';
import { buildSimpleStatementRows } from '../matrix/buildSimpleStatementRows';
import { resolveMatrixScaleOptions } from '../matrix/resolveMatrixScaleOptions';

export function mapRatingMatrixQuestion(
  raw: ApiQuestion,
  shell: ResolvedQuestionShell,
  language?: string
): RatingMatrixQuestion {
  const configs = raw.questionConfigs ?? [];
  const { scaleColumns, scaleAnchorLabels, hasNotApplicableOption, reverseScaleOrder } =
    resolveMatrixScaleOptions(raw, configs, language, buildScaleColumns(raw, language));

  const { minLabel, maxLabel } = extractHintLabels(raw.answerDetails, language);

  return {
    ...shell,
    type: QUESTION_TYPE.RATING_MATRIX,
    statementRows: buildSimpleStatementRows(raw, language),
    scaleColumns,
    ...(minLabel ? { minLabel } : {}),
    ...(maxLabel ? { maxLabel } : {}),
    displayStyle: detectDisplayStyle(configs, raw.dataSubType),
    hasNotApplicableOption,
    reverseScaleOrder,
    gridLayout: detectMatrixFormat(configs),
    ...(scaleAnchorLabels.length > 0 ? { scaleAnchorLabels } : {}),
  };
}
